import multiCascader from './index.vue'

multiCascader.install = Vue => {
  Vue.component(multiCascader.name, multiCascader)
}

export default multiCascader


// WEBPACK FOOTER //
// ./src/components/multi-cascader/index.js